export const createSnowEffect = (effectLayer, settings) => {
  try {
    // Amount of Snowflakes
    const snowMax = settings.intensity;

    // Snowflake Colours
    const snowColor = ['#DDD', '#EEE'];

    // Snow Entity
    const snowEntity = '&#x2022;';

    // Falling Velocity
    const snowSpeed = settings.speed / 100;

    // Minimum Flake Size
    const snowMinSize = settings.size - 12;

    // Maximum Flake Size
    const snowMaxSize = settings.size + 12;

    // Refresh Rate (in milliseconds)
    const snowRefresh = 50;

    // Additional Styles
    const snowStyles = 'cursor: default; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; -o-user-select: none; user-select: none;';


    const snow = [];
    const pos = [];
    const coords = [];
    const lefr = [];
    let marginBottom = 0;
    let marginRight = 0;

    const randomise = range => Math.floor(range * Math.random());

    const moveSnow = () => {
      for (let i = 0; i <= snowMax; i++) {
        coords[i] += pos[i];
        snow[i].posY += snow[i].sink;
        snow[i].style.left = snow[i].posX + lefr[i] * Math.sin(coords[i]) + "px";
        snow[i].style.top = snow[i].posY + "px";

        if (snow[i].posY >= marginBottom - 0 * snow[i].size || parseInt(snow[i].style.left) > (marginRight - 0 * lefr[i])) {
          snow[i].posX = randomise(marginRight - snow[i].size);
          snow[i].posY = 0;
        }
      }

      setTimeout(moveSnow, snowRefresh);
    }

    const initSnow = () => {
      const snowSize = snowMaxSize - snowMinSize;
      marginBottom = effectLayer.getBoundingClientRect().height;
      marginRight = effectLayer.getBoundingClientRect().width;

      for (let i = 0; i <= snowMax; i++) {
        coords[i] = 0;
        lefr[i] = Math.random() * 15;
        pos[i] = 0.03 + Math.random() / 10;
        snow[i] = document.getElementById(`flake${i}`);
        snow[i].style.fontFamily = 'inherit';
        snow[i].size = randomise(snowSize) + snowMinSize;
        snow[i].style.fontSize = `${snow[i].size}px`;
        snow[i].style.color = snowColor[randomise(snowColor.length)];
        snow[i].style.zIndex = 1000;
        snow[i].sink = snowSpeed * snow[i].size / 5;
        snow[i].posX = randomise(marginRight - snow[i].size);
        snow[i].posY = randomise(2 * marginBottom - marginBottom - 0 * snow[i].size);
        snow[i].style.left = `${snow[i].posX}px`;
        snow[i].style.top = `${snow[i].posY}px`;
      }
      moveSnow();
    };

    const resize = () => {
      marginBottom = document.body.scrollHeight;
      marginRight = document.body.clientWidth;
    }

    for (let i = 0; i <= snowMax; i++) {
      const flake = document.createElement('span');
      flake.id = `flake${i}`;
      flake.style = `${snowStyles}position:absolute;top:-${snowMaxSize}`;
      flake.innerHTML = snowEntity;
      effectLayer.appendChild(flake);
    }
    initSnow();
  } catch (e) {
    console.log(e);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/effects/snow.js